import { render, staticRenderFns } from "./books_tab.vue?vue&type=template&id=b627ac00"
import script from "./books_tab.vue?vue&type=script&lang=js"
export * from "./books_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports